import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { Socket } from 'ngx-socket-io';
import { from, Observable, of } from 'rxjs';
import { catchError, map, mergeMap, reduce, switchMap } from 'rxjs/operators';
import { ApiService } from './api.service';
import { RequestService } from './request.service';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo, AuthenticationResult } from '@azure/msal-browser';

@Injectable({
  	providedIn: 'root'
})
export class MicrosoftService extends RequestService {

    get baseUrl () {return 'https://graph.microsoft.com/beta/'};
    
    get baseScopes () { return [
        "Directory.AccessAsUser.All",
        "Directory.ReadWrite.All",
        "Files.ReadWrite.All",
        "Group.Read.All",
        "Sites.Read.All"
    ]};

    get baseHeaders (): Observable<{[name: string]: string}> {

        if(this.apiService.impersonated)
            return of({});

        const account = this.msalService.instance.getAccountByLocalId(this.apiService.me.guid);
        return from(this.msalService.instance.acquireTokenSilent({scopes: this.baseScopes, account}))
                .pipe(map(authResponse => ({'Authorization': 'Bearer '+ authResponse.accessToken})));
    };

	get isAuthenticated (): boolean | Observable<boolean> {

        if(this.apiService.impersonated)
            return false;

        const account = this.msalService.instance.getAccountByLocalId(this.apiService.me.guid);     
        return this.authenticate(account);
    }

	get beforeRequest (): boolean | Observable<boolean> { return this.isAuthenticated; }

	constructor(http: HttpClient, protected apiService: ApiService, protected msalService: MsalService) { super(http); }

    authenticate (account?: AccountInfo): Observable<boolean> {
        return this.msalService.initialize().pipe(
            switchMap(() => 
                account ?
                this.msalService.acquireTokenSilent({
                    scopes: this.baseScopes,
                    account
                }) :
                this.msalService.loginRedirect({
                    scopes: this.baseScopes,
                    prompt: "select_account"
                })
            ),
            map(() => true),
            catchError(() => {
                return (account ?
                    this.msalService.loginRedirect({
                        scopes: this.baseScopes,
                        account
                    }) :
                    this.msalService.loginRedirect({
                        scopes: this.baseScopes,
                        prompt: "select_account"
                    })
                ).pipe(map(() => false))
            })
        );
    }

    acquireCurrentTokenSilent (): Observable<AuthenticationResult> {
        const account = this.msalService.instance.getAccountByLocalId(this.apiService.me.guid);     
        return this.msalService.acquireTokenSilent({scopes: this.baseScopes, account});
    }

	batch (requests: {
		id: number | string,
		method: 'GET' | 'POST' | 'PATCH' | 'DELETE',
		url: string,
		body?: any,
		headers?: any
	}[], options: any = {}): Observable<{id: string, value: any}[]> {
		
		requests = requests.map(request => {

			if(request.body)
				request.headers = {"Content-Type": "application/json"}

			return request;
		});
		
		return from(requests.chunk(20)).pipe(
			mergeMap(requests => this.post('$batch', {requests}, options)),
			reduce((all, {responses}) => ({responses: [...all.responses, ...responses]}), {responses: []}),
			map(({responses}) => responses.map(({id, body}) => ({id, value: body})))
		);
	}

	// socket (url: string): Observable<Socket> {
	// 	return this.get(`${url}/subscriptions/socketIo`).pipe(
	// 		map(response => {
	// 			const socket = new Socket({url: response.notificationUrl, options: {transports: ['websocket', 'polling']}});
				
	// 			socket.on('connect_error', () => {
	// 				if(!this.isAuthenticated) {
	// 					socket.ioSocket.autoConnect = false;
	// 					socket.ioSocket.reconnection = false;
	// 					socket.disconnect();
	// 				}
	// 			})

	// 			return socket;
	// 		})
	// 	);
	// }
}